import styled from '@emotion/styled';
import Typography from '@portalterreno/react-ui-core/Typography';

const StyledSubtitle = styled(Typography)({
  lineHeight: '22px',
  marginTop: 12,
  marginBottom: 0
});

export default StyledSubtitle;
